webpackJsonp(["cycle_analytics"],{

/***/ "../../../node_modules/vue-loader/lib/component-normalizer.js":
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "../images/no_avatar.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAAAAAAdJSU2AAACNElEQVR4AdXYBa7jMBCA4b3/JZahzIkjp2qt+BWUWnG5ln2XxaJJb2b5F2ukL4wvzK/rP7bUcbf92u6oftLSe1ldk8efsfaVeEjusZZeC6e1RllaCk/yG6ag1lZ4WwPX69uyD6tAe/g2ipAlNMRS37awDLaFrpcMWxXQOi0jnWCWjFkSZomYJWDWKmatYNZyEWkJsvQimoZYah5NgdaLxagCtF6GRy0DshZPkeYwS/KIJWGWYjwYUzDLxCwDtJ54OKglimBLqHWahii2g1pmHLLGBmwVoRjcKlmgOdw65H5qKuGWCVi5Qlhs6m1sENZi4q3AWNvca5UYy2RjT/SAsiZey6CsIvc0wVlV5lJ0ibPMyLUGCmlxQq0IM0hLdWyro7CWEc3sXsqaK4O2zLxOsmtpfW5Q1u68ZrVmepaaNXEewawtI9X5Xl3U3n1qND6+rfPzvqoIWz/fklNCSLY153YV53J/XUxGCJnKZ1lajsn3/Ffegf6Y5pV2LUsSNL2UHzxUfh3TlYpZqqTpXZm0KZk9zJcqaEmaWPHDw0pxe05K7bWOLHFLWXVetqpYmrjle4+1y0aBaF4UOQ1NU+lYezJClkjLUnSEjqhH6zjAW4OjtY39Ibq+sawUb6W2RQfoqG0VeKuwrRJvlba17faRdbe2pTtYq6Nty/S7yAbGsQjWIq41wVoT1+IdZNy1djUcVdu5lklQWC0xHkt1X31qNEE1Pr3qKv/9XiSNj6Aaifj3/69+AYujsR/MvkpZAAAAAElFTkSuQmCC"

/***/ }),

/***/ "./cycle_analytics/components/limit_warning_component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    count: {
      type: Number,
      required: true
    }
  },
  template: "\n    <span v-if=\"count === 50\" class=\"events-info pull-right\">\n      <i class=\"fa fa-warning has-tooltip\"\n          aria-hidden=\"true\"\n          :title=\"n__('Limited to showing %d event at most', 'Limited to showing %d events at most', 50)\"\n          data-placement=\"top\"></i>\n      {{ n__('Showing %d event', 'Showing %d events', 50) }}\n    </span>\n  "
});

/***/ }),

/***/ "./cycle_analytics/components/stage_code_component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue__ = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue__);
/* eslint-disable no-param-reassign */




var global = window.gl || (window.gl = {});
global.cycleAnalytics = global.cycleAnalytics || {};

global.cycleAnalytics.StageCodeComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    items: Array,
    stage: Object
  },
  components: {
    userAvatarImage: __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue___default.a
  },
  template: '\n    <div>\n      <div class="events-description">\n        {{ stage.description }}\n        <limit-warning :count="items.length" />\n      </div>\n      <ul class="stage-event-list">\n        <li v-for="mergeRequest in items" class="stage-event-item">\n          <div class="item-details">\n            <!-- FIXME: Pass an alt attribute here for accessibility -->\n            <user-avatar-image :img-src="mergeRequest.author.avatarUrl"/>\n            <h5 class="item-title merge-merquest-title">\n              <a :href="mergeRequest.url">\n                {{ mergeRequest.title }}\n              </a>\n            </h5>\n            <a :href="mergeRequest.url" class="issue-link">!{{ mergeRequest.iid }}</a>\n            &middot;\n            <span>\n              {{ s__(\'OpenedNDaysAgo|Opened\') }}\n              <a :href="mergeRequest.url" class="issue-date">{{ mergeRequest.createdAt }}</a>\n            </span>\n            <span>\n              {{ s__(\'ByAuthor|by\') }}\n              <a :href="mergeRequest.author.webUrl" class="issue-author-link">{{ mergeRequest.author.name }}</a>\n            </span>\n          </div>\n          <div class="item-time">\n            <total-time :time="mergeRequest.totalTime"></total-time>\n          </div>\n        </li>\n      </ul>\n    </div>\n  '
});

/***/ }),

/***/ "./cycle_analytics/components/stage_issue_component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue__ = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue__);
/* eslint-disable no-param-reassign */



var global = window.gl || (window.gl = {});
global.cycleAnalytics = global.cycleAnalytics || {};

global.cycleAnalytics.StageIssueComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    items: Array,
    stage: Object
  },
  components: {
    userAvatarImage: __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue___default.a
  },
  template: '\n    <div>\n      <div class="events-description">\n        {{ stage.description }}\n        <limit-warning :count="items.length" />\n      </div>\n      <ul class="stage-event-list">\n        <li v-for="issue in items" class="stage-event-item">\n          <div class="item-details">\n            <!-- FIXME: Pass an alt attribute here for accessibility -->\n            <user-avatar-image :img-src="issue.author.avatarUrl"/>\n            <h5 class="item-title issue-title">\n              <a class="issue-title" :href="issue.url">\n                {{ issue.title }}\n              </a>\n            </h5>\n            <a :href="issue.url" class="issue-link">#{{ issue.iid }}</a>\n            &middot;\n            <span>\n              {{ s__(\'OpenedNDaysAgo|Opened\') }}\n              <a :href="issue.url" class="issue-date">{{ issue.createdAt }}</a>\n            </span>\n            <span>\n              {{ s__(\'ByAuthor|by\') }}\n              <a :href="issue.author.webUrl" class="issue-author-link">\n                {{ issue.author.name }}\n              </a>\n            </span>\n          </div>\n          <div class="item-time">\n            <total-time :time="issue.totalTime"></total-time>\n          </div>\n        </li>\n      </ul>\n    </div>\n  '
});

/***/ }),

/***/ "./cycle_analytics/components/stage_plan_component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue__ = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_icon_commit_svg__ = __webpack_require__("./cycle_analytics/svg/icon_commit.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_icon_commit_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_icon_commit_svg__);
/* eslint-disable no-param-reassign */




var global = window.gl || (window.gl = {});
global.cycleAnalytics = global.cycleAnalytics || {};

global.cycleAnalytics.StagePlanComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    items: Array,
    stage: Object
  },
  components: {
    userAvatarImage: __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue___default.a
  },
  data: function data() {
    return { iconCommit: __WEBPACK_IMPORTED_MODULE_2__svg_icon_commit_svg___default.a };
  },

  template: '\n    <div>\n      <div class="events-description">\n        {{ stage.description }}\n        <limit-warning :count="items.length" />\n      </div>\n      <ul class="stage-event-list">\n        <li v-for="commit in items" class="stage-event-item">\n          <div class="item-details item-conmmit-component">\n            <!-- FIXME: Pass an alt attribute here for accessibility -->\n            <user-avatar-image :img-src="commit.author.avatarUrl"/>\n            <h5 class="item-title commit-title">\n              <a :href="commit.commitUrl">\n                {{ commit.title }}\n              </a>\n            </h5>\n            <span>\n              {{ s__(\'FirstPushedBy|First\') }}\n              <span class="commit-icon">' + __WEBPACK_IMPORTED_MODULE_2__svg_icon_commit_svg___default.a + '</span>\n              <a :href="commit.commitUrl" class="commit-hash-link commit-sha">{{ commit.shortSha }}</a>\n              {{ s__(\'FirstPushedBy|pushed by\') }}\n              <a :href="commit.author.webUrl" class="commit-author-link">\n                {{ commit.author.name }}\n              </a>\n            </span>\n          </div>\n          <div class="item-time">\n            <total-time :time="commit.totalTime"></total-time>\n          </div>\n        </li>\n      </ul>\n    </div>\n  '
});

/***/ }),

/***/ "./cycle_analytics/components/stage_production_component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue__ = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue__);
/* eslint-disable no-param-reassign */



var global = window.gl || (window.gl = {});
global.cycleAnalytics = global.cycleAnalytics || {};

global.cycleAnalytics.StageProductionComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    items: Array,
    stage: Object
  },
  components: {
    userAvatarImage: __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue___default.a
  },
  template: '\n    <div>\n      <div class="events-description">\n        {{ stage.description }}\n        <limit-warning :count="items.length" />\n      </div>\n      <ul class="stage-event-list">\n        <li v-for="issue in items" class="stage-event-item">\n          <div class="item-details">\n            <!-- FIXME: Pass an alt attribute here for accessibility -->\n            <user-avatar-image :img-src="issue.author.avatarUrl"/>\n            <h5 class="item-title issue-title">\n              <a class="issue-title" :href="issue.url">\n                {{ issue.title }}\n              </a>\n            </h5>\n            <a :href="issue.url" class="issue-link">#{{ issue.iid }}</a>\n            &middot;\n            <span>\n              {{ s__(\'OpenedNDaysAgo|Opened\') }}\n              <a :href="issue.url" class="issue-date">{{ issue.createdAt }}</a>\n            </span>\n            <span>\n            {{ s__(\'ByAuthor|by\') }}\n            <a :href="issue.author.webUrl" class="issue-author-link">\n              {{ issue.author.name }}\n            </a>\n            </span>\n          </div>\n          <div class="item-time">\n            <total-time :time="issue.totalTime"></total-time>\n          </div>\n        </li>\n      </ul>\n    </div>\n  '
});

/***/ }),

/***/ "./cycle_analytics/components/stage_review_component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue__ = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue__);
/* eslint-disable no-param-reassign */



var global = window.gl || (window.gl = {});
global.cycleAnalytics = global.cycleAnalytics || {};

global.cycleAnalytics.StageReviewComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    items: Array,
    stage: Object
  },
  components: {
    userAvatarImage: __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue___default.a
  },
  template: '\n    <div>\n      <div class="events-description">\n        {{ stage.description }}\n        <limit-warning :count="items.length" />\n      </div>\n      <ul class="stage-event-list">\n        <li v-for="mergeRequest in items" class="stage-event-item">\n          <div class="item-details">\n            <!-- FIXME: Pass an alt attribute here for accessibility -->\n            <user-avatar-image :img-src="mergeRequest.author.avatarUrl"/>\n            <h5 class="item-title merge-merquest-title">\n              <a :href="mergeRequest.url">\n                {{ mergeRequest.title }}\n              </a>\n            </h5>\n            <a :href="mergeRequest.url" class="issue-link">!{{ mergeRequest.iid }}</a>\n            &middot;\n            <span>\n              {{ s__(\'OpenedNDaysAgo|Opened\') }}\n              <a :href="mergeRequest.url" class="issue-date">{{ mergeRequest.createdAt }}</a>\n            </span>\n            <span>\n              {{ s__(\'ByAuthor|by\') }}\n              <a :href="mergeRequest.author.webUrl" class="issue-author-link">{{ mergeRequest.author.name }}</a>\n            </span>\n            <template v-if="mergeRequest.state === \'closed\'">\n              <span class="merge-request-state">\n                <i class="fa fa-ban"></i>\n                {{ mergeRequest.state.toUpperCase() }}\n              </span>\n            </template>\n            <template v-else>\n              <span class="merge-request-branch" v-if="mergeRequest.branch">\n                <i class= "fa fa-code-fork"></i>\n                <a :href="mergeRequest.branch.url">{{ mergeRequest.branch.name }}</a>\n              </span>\n            </template>\n          </div>\n          <div class="item-time">\n            <total-time :time="mergeRequest.totalTime"></total-time>\n          </div>\n        </li>\n      </ul>\n    </div>\n  '
});

/***/ }),

/***/ "./cycle_analytics/components/stage_staging_component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue__ = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_icon_branch_svg__ = __webpack_require__("./cycle_analytics/svg/icon_branch.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_icon_branch_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_icon_branch_svg__);
/* eslint-disable no-param-reassign */




var global = window.gl || (window.gl = {});
global.cycleAnalytics = global.cycleAnalytics || {};

global.cycleAnalytics.StageStagingComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    items: Array,
    stage: Object
  },
  data: function data() {
    return { iconBranch: __WEBPACK_IMPORTED_MODULE_2__svg_icon_branch_svg___default.a };
  },

  components: {
    userAvatarImage: __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_image_vue___default.a
  },
  template: '\n    <div>\n      <div class="events-description">\n        {{ stage.description }}\n        <limit-warning :count="items.length" />\n      </div>\n      <ul class="stage-event-list">\n        <li v-for="build in items" class="stage-event-item item-build-component">\n          <div class="item-details">\n            <!-- FIXME: Pass an alt attribute here for accessibility -->\n            <user-avatar-image :img-src="build.author.avatarUrl"/>\n            <h5 class="item-title">\n              <a :href="build.url" class="pipeline-id">#{{ build.id }}</a>\n              <i class="fa fa-code-fork"></i>\n              <a :href="build.branch.url" class="ref-name">{{ build.branch.name }}</a>\n              <span class="icon-branch">' + __WEBPACK_IMPORTED_MODULE_2__svg_icon_branch_svg___default.a + '</span>\n              <a :href="build.commitUrl" class="commit-sha">{{ build.shortSha }}</a>\n            </h5>\n            <span>\n              <a :href="build.url" class="build-date">{{ build.date }}</a>\n              {{ s__(\'ByAuthor|by\') }}\n              <a :href="build.author.webUrl" class="issue-author-link">\n                {{ build.author.name }}\n              </a>\n            </span>\n          </div>\n          <div class="item-time">\n            <total-time :time="build.totalTime"></total-time>\n          </div>\n        </li>\n      </ul>\n    </div>\n  '
});

/***/ }),

/***/ "./cycle_analytics/components/stage_test_component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_icon_build_status_svg__ = __webpack_require__("./cycle_analytics/svg/icon_build_status.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_icon_build_status_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__svg_icon_build_status_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_icon_branch_svg__ = __webpack_require__("./cycle_analytics/svg/icon_branch.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_icon_branch_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_icon_branch_svg__);
/* eslint-disable no-param-reassign */




var global = window.gl || (window.gl = {});
global.cycleAnalytics = global.cycleAnalytics || {};

global.cycleAnalytics.StageTestComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    items: Array,
    stage: Object
  },
  data: function data() {
    return { iconBuildStatus: __WEBPACK_IMPORTED_MODULE_1__svg_icon_build_status_svg___default.a, iconBranch: __WEBPACK_IMPORTED_MODULE_2__svg_icon_branch_svg___default.a };
  },

  template: '\n    <div>\n      <div class="events-description">\n        {{ stage.description }}\n        <limit-warning :count="items.length" />\n      </div>\n      <ul class="stage-event-list">\n        <li v-for="build in items" class="stage-event-item item-build-component">\n          <div class="item-details">\n            <h5 class="item-title">\n              <span class="icon-build-status">' + __WEBPACK_IMPORTED_MODULE_1__svg_icon_build_status_svg___default.a + '</span>\n              <a :href="build.url" class="item-build-name">{{ build.name }}</a>\n              &middot;\n              <a :href="build.url" class="pipeline-id">#{{ build.id }}</a>\n              <i class="fa fa-code-fork"></i>\n              <a :href="build.branch.url" class="ref-name">{{ build.branch.name }}</a>\n              <span class="icon-branch">' + __WEBPACK_IMPORTED_MODULE_2__svg_icon_branch_svg___default.a + '</span>\n              <a :href="build.commitUrl" class="commit-sha">{{ build.shortSha }}</a>\n            </h5>\n            <span>\n              <a :href="build.url" class="issue-date">\n                {{ build.date }}\n              </a>\n            </span>\n          </div>\n          <div class="item-time">\n            <total-time :time="build.totalTime"></total-time>\n          </div>\n        </li>\n      </ul>\n    </div>\n  '
});

/***/ }),

/***/ "./cycle_analytics/components/total_time_component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* eslint-disable no-param-reassign */



var global = window.gl || (window.gl = {});
global.cycleAnalytics = global.cycleAnalytics || {};

global.cycleAnalytics.TotalTimeComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    time: Object
  },
  template: '\n    <span class="total-time">\n      <template v-if="Object.keys(time).length">\n        <template v-if="time.days">{{ time.days }} <span>{{ n__(\'day\', \'days\', time.days) }}</span></template>\n        <template v-if="time.hours">{{ time.hours }} <span>{{ n__(\'Time|hr\', \'Time|hrs\', time.hours) }}</span></template>\n        <template v-if="time.mins && !time.days">{{ time.mins }} <span>{{ n__(\'Time|min\', \'Time|mins\', time.mins) }}</span></template>\n        <template v-if="time.seconds && Object.keys(time).length === 1 || time.seconds === 0">{{ time.seconds }} <span>{{ s__(\'Time|s\') }}</span></template>\n      </template>\n      <template v-else>\n        --\n      </template>\n    </span>\n  '
});

/***/ }),

/***/ "./cycle_analytics/cycle_analytics_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_translate__ = __webpack_require__("./vue_shared/translate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_limit_warning_component__ = __webpack_require__("./cycle_analytics/components/limit_warning_component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_stage_code_component__ = __webpack_require__("./cycle_analytics/components/stage_code_component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_stage_issue_component__ = __webpack_require__("./cycle_analytics/components/stage_issue_component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_stage_plan_component__ = __webpack_require__("./cycle_analytics/components/stage_plan_component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_stage_production_component__ = __webpack_require__("./cycle_analytics/components/stage_production_component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_stage_review_component__ = __webpack_require__("./cycle_analytics/components/stage_review_component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_stage_staging_component__ = __webpack_require__("./cycle_analytics/components/stage_staging_component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_stage_test_component__ = __webpack_require__("./cycle_analytics/components/stage_test_component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_total_time_component__ = __webpack_require__("./cycle_analytics/components/total_time_component.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__cycle_analytics_service__ = __webpack_require__("./cycle_analytics/cycle_analytics_service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__cycle_analytics_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__cycle_analytics_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__cycle_analytics_store__ = __webpack_require__("./cycle_analytics/cycle_analytics_store.js");
/* global Flash */
















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2__vue_shared_translate__["a" /* default */]);

$(function () {
  var OVERVIEW_DIALOG_COOKIE = 'cycle_analytics_help_dismissed';
  var cycleAnalyticsEl = document.querySelector('#cycle-analytics');
  var cycleAnalyticsStore = gl.cycleAnalytics.CycleAnalyticsStore;
  var cycleAnalyticsService = new gl.cycleAnalytics.CycleAnalyticsService({
    requestPath: cycleAnalyticsEl.dataset.requestPath
  });

  gl.cycleAnalyticsApp = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#cycle-analytics',
    name: 'CycleAnalytics',
    data: {
      state: cycleAnalyticsStore.state,
      isLoading: false,
      isLoadingStage: false,
      isEmptyStage: false,
      hasError: false,
      startDate: 30,
      isOverviewDialogDismissed: __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get(OVERVIEW_DIALOG_COOKIE)
    },
    computed: {
      currentStage: function currentStage() {
        return cycleAnalyticsStore.currentActiveStage();
      }
    },
    components: {
      'stage-issue-component': gl.cycleAnalytics.StageIssueComponent,
      'stage-plan-component': gl.cycleAnalytics.StagePlanComponent,
      'stage-code-component': gl.cycleAnalytics.StageCodeComponent,
      'stage-test-component': gl.cycleAnalytics.StageTestComponent,
      'stage-review-component': gl.cycleAnalytics.StageReviewComponent,
      'stage-staging-component': gl.cycleAnalytics.StageStagingComponent,
      'stage-production-component': gl.cycleAnalytics.StageProductionComponent
    },
    created: function created() {
      this.fetchCycleAnalyticsData();
    },

    methods: {
      handleError: function handleError() {
        cycleAnalyticsStore.setErrorState(true);
        return new Flash('There was an error while fetching cycle analytics data.');
      },
      initDropdown: function initDropdown() {
        var _this = this;

        var $dropdown = $('.js-ca-dropdown');
        var $label = $dropdown.find('.dropdown-label');

        $dropdown.find('li a').off('click').on('click', function (e) {
          e.preventDefault();
          var $target = $(e.currentTarget);
          _this.startDate = $target.data('value');

          $label.text($target.text().trim());
          _this.fetchCycleAnalyticsData({ startDate: _this.startDate });
        });
      },
      fetchCycleAnalyticsData: function fetchCycleAnalyticsData(options) {
        var _this2 = this;

        var fetchOptions = options || { startDate: this.startDate };

        this.isLoading = true;

        cycleAnalyticsService.fetchCycleAnalyticsData(fetchOptions).done(function (response) {
          cycleAnalyticsStore.setCycleAnalyticsData(response);
          _this2.selectDefaultStage();
          _this2.initDropdown();
        }).error(function () {
          _this2.handleError();
        }).always(function () {
          _this2.isLoading = false;
        });
      },
      selectDefaultStage: function selectDefaultStage() {
        var stage = this.state.stages[0];
        this.selectStage(stage);
      },
      selectStage: function selectStage(stage) {
        var _this3 = this;

        if (this.isLoadingStage) return;
        if (this.currentStage === stage) return;

        if (!stage.isUserAllowed) {
          cycleAnalyticsStore.setActiveStage(stage);
          return;
        }

        this.isLoadingStage = true;
        cycleAnalyticsStore.setStageEvents([], stage);
        cycleAnalyticsStore.setActiveStage(stage);

        cycleAnalyticsService.fetchStageData({
          stage: stage,
          startDate: this.startDate
        }).done(function (response) {
          _this3.isEmptyStage = !response.events.length;
          cycleAnalyticsStore.setStageEvents(response.events, stage);
        }).error(function () {
          _this3.isEmptyStage = true;
        }).always(function () {
          _this3.isLoadingStage = false;
        });
      },
      dismissOverviewDialog: function dismissOverviewDialog() {
        this.isOverviewDialogDismissed = true;
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(OVERVIEW_DIALOG_COOKIE, '1', { expires: 365 });
      }
    }
  });

  // Register global components
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('limit-warning', __WEBPACK_IMPORTED_MODULE_3__components_limit_warning_component__["a" /* default */]);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('total-time', gl.cycleAnalytics.TotalTimeComponent);
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./cycle_analytics/cycle_analytics_service.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-param-reassign */

var global = window.gl || (window.gl = {});
global.cycleAnalytics = global.cycleAnalytics || {};

var CycleAnalyticsService = function () {
  function CycleAnalyticsService(options) {
    _classCallCheck(this, CycleAnalyticsService);

    this.requestPath = options.requestPath;
  }

  _createClass(CycleAnalyticsService, [{
    key: 'fetchCycleAnalyticsData',
    value: function fetchCycleAnalyticsData(options) {
      options = options || { startDate: 30 };

      return $.ajax({
        url: this.requestPath,
        method: 'GET',
        dataType: 'json',
        contentType: 'application/json',
        data: {
          cycle_analytics: {
            start_date: options.startDate
          }
        }
      });
    }
  }, {
    key: 'fetchStageData',
    value: function fetchStageData(options) {
      var stage = options.stage,
          startDate = options.startDate;


      return $.get(this.requestPath + '/events/' + stage.name + '.json', {
        cycle_analytics: {
          start_date: startDate
        }
      });
    }
  }]);

  return CycleAnalyticsService;
}();

global.cycleAnalytics.CycleAnalyticsService = CycleAnalyticsService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./cycle_analytics/cycle_analytics_store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_text_utility__ = __webpack_require__("./lib/utils/text_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__default_event_objects__ = __webpack_require__("./cycle_analytics/default_event_objects.js");
/* eslint-disable no-param-reassign */





var global = window.gl || (window.gl = {});
global.cycleAnalytics = global.cycleAnalytics || {};

var EMPTY_STAGE_TEXTS = {
  issue: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["__"])('The issue stage shows the time it takes from creating an issue to assigning the issue to a milestone, or add the issue to a list on your Issue Board. Begin creating issues to see data for this stage.'),
  plan: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["__"])('The planning stage shows the time from the previous step to pushing your first commit. This time will be added automatically once you push your first commit.'),
  code: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["__"])('The coding stage shows the time from the first commit to creating the merge request. The data will automatically be added here once you create your first merge request.'),
  test: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["__"])('The testing stage shows the time GitLab CI takes to run every pipeline for the related merge request. The data will automatically be added after your first pipeline finishes running.'),
  review: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["__"])('The review stage shows the time from creating the merge request to merging it. The data will automatically be added after you merge your first merge request.'),
  staging: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["__"])('The staging stage shows the time between merging the MR and deploying code to the production environment. The data will be automatically added once you deploy to production for the first time.'),
  production: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["__"])('The production stage shows the total time it takes between creating an issue and deploying the code to production. The data will be automatically added once you have completed the full idea to production cycle.')
};

global.cycleAnalytics.CycleAnalyticsStore = {
  state: {
    summary: '',
    stats: '',
    analytics: '',
    events: [],
    stages: []
  },
  setCycleAnalyticsData: function setCycleAnalyticsData(data) {
    this.state = Object.assign(this.state, this.decorateData(data));
  },
  decorateData: function decorateData(data) {
    var newData = {};

    newData.stages = data.stats || [];
    newData.summary = data.summary || [];

    newData.summary.forEach(function (item) {
      item.value = item.value || '-';
    });

    newData.stages.forEach(function (item) {
      var stageSlug = gl.text.dasherize(item.name.toLowerCase());
      item.active = false;
      item.isUserAllowed = data.permissions[stageSlug];
      item.emptyStageText = EMPTY_STAGE_TEXTS[stageSlug];
      item.component = 'stage-' + stageSlug + '-component';
      item.slug = stageSlug;
    });
    newData.analytics = data;
    return newData;
  },
  setLoadingState: function setLoadingState(state) {
    this.state.isLoading = state;
  },
  setErrorState: function setErrorState(state) {
    this.state.hasError = state;
  },
  deactivateAllStages: function deactivateAllStages() {
    this.state.stages.forEach(function (stage) {
      stage.active = false;
    });
  },
  setActiveStage: function setActiveStage(stage) {
    this.deactivateAllStages();
    stage.active = true;
  },
  setStageEvents: function setStageEvents(events, stage) {
    this.state.events = this.decorateEvents(events, stage);
  },
  decorateEvents: function decorateEvents(events, stage) {
    var newEvents = [];

    events.forEach(function (item) {
      if (!item) return;

      var eventItem = Object.assign({}, __WEBPACK_IMPORTED_MODULE_2__default_event_objects__["a" /* default */][stage.slug], item);

      eventItem.totalTime = eventItem.total_time;

      if (eventItem.author) {
        eventItem.author.webUrl = eventItem.author.web_url;
        eventItem.author.avatarUrl = eventItem.author.avatar_url;
      }

      if (eventItem.created_at) eventItem.createdAt = eventItem.created_at;
      if (eventItem.short_sha) eventItem.shortSha = eventItem.short_sha;
      if (eventItem.commit_url) eventItem.commitUrl = eventItem.commit_url;

      delete eventItem.author.web_url;
      delete eventItem.author.avatar_url;
      delete eventItem.total_time;
      delete eventItem.created_at;
      delete eventItem.short_sha;
      delete eventItem.commit_url;

      newEvents.push(eventItem);
    });

    return newEvents;
  },
  currentActiveStage: function currentActiveStage() {
    return this.state.stages.find(function (stage) {
      return stage.active;
    });
  }
};

/***/ }),

/***/ "./cycle_analytics/default_event_objects.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  issue: {
    created_at: '',
    url: '',
    iid: '',
    title: '',
    total_time: {},
    author: {
      avatar_url: '',
      id: '',
      name: '',
      web_url: ''
    }
  },
  plan: {
    title: '',
    commit_url: '',
    short_sha: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: ''
    }
  },
  code: {
    title: '',
    iid: '',
    created_at: '',
    url: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: ''
    }
  },
  test: {
    name: '',
    id: '',
    date: '',
    url: '',
    short_sha: '',
    commit_url: '',
    total_time: {},
    branch: {
      name: '',
      url: ''
    }
  },
  review: {
    title: '',
    iid: '',
    created_at: '',
    url: '',
    state: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: ''
    }
  },
  staging: {
    id: '',
    short_sha: '',
    date: '',
    url: '',
    commit_url: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: ''
    },
    branch: {
      name: '',
      url: ''
    }
  },
  production: {
    title: '',
    created_at: '',
    url: '',
    iid: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: ''
    }
  }
});

/***/ }),

/***/ "./cycle_analytics/svg/icon_branch.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\"><path fill=\"#8C8C8C\" fill-rule=\"evenodd\" d=\"M9.678 6.722C9.353 5.167 8.053 4 6.5 4S3.647 5.167 3.322 6.722h-2.6c-.397 0-.722.35-.722.778 0 .428.325.778.722.778h2.6C3.647 9.833 4.947 11 6.5 11s2.853-1.167 3.178-2.722h2.6c.397 0 .722-.35.722-.778 0-.428-.325-.778-.722-.778h-2.6zM4.694 7.5c0-1.09.795-1.944 1.806-1.944 1.01 0 1.806.855 1.806 1.944 0 1.09-.795 1.944-1.806 1.944-1.01 0-1.806-.855-1.806-1.944z\"/></svg>\n"

/***/ }),

/***/ "./cycle_analytics/svg/icon_build_status.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\"><g fill=\"#31AF64\" fill-rule=\"evenodd\"><path d=\"M12.5 7c0-3.038-2.462-5.5-5.5-5.5S1.5 3.962 1.5 7s2.462 5.5 5.5 5.5 5.5-2.462 5.5-5.5zM0 7c0-3.866 3.134-7 7-7s7 3.134 7 7-3.134 7-7 7-7-3.134-7-7z\"/><path d=\"M6.28 7.697L5.045 6.464c-.117-.117-.305-.117-.42-.002l-.614.614c-.11.113-.11.303.007.42l1.91 1.91c.19.19.51.197.703.004l.264-.265L9.997 6.04c.108-.107.107-.293-.01-.408l-.612-.614c-.114-.113-.298-.12-.41-.01L6.28 7.7z\"/></g></svg>\n"

/***/ }),

/***/ "./cycle_analytics/svg/icon_commit.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\"><path fill=\"#8F8F8F\" fill-rule=\"evenodd\" d=\"M28.777 18c-.91-4.008-4.494-7-8.777-7-4.283 0-7.868 2.992-8.777 7H4.01C2.9 18 2 18.895 2 20c0 1.112.9 2 2.01 2h7.213c.91 4.008 4.494 7 8.777 7 4.283 0 7.868-2.992 8.777-7h7.214C37.1 22 38 21.105 38 20c0-1.112-.9-2-2.01-2h-7.213zM20 25c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5z\"/></svg>\n"

/***/ })

},["./cycle_analytics/cycle_analytics_bundle.js"]);


// WEBPACK FOOTER //
// cycle_analytics.d43ff8f872079c12e386.bundle.js